define('ordersMollieUtils',[
  'app',
  'module',
  'underscore',
  'settings', 
  'entities/customers/customers',
  'entities/orders'
], function (
  App,
  module,
  _,
  Settings
) {
  'use strict';

  module.exports = {
    getMolliePaymentLinkTotal: function (models) {
      var defer = $.Deferred();

      var pois = [];
      _.each(models, function (model) { 
        pois.push(model.get('purchaseOrderId'));
      }, this);

      var params = {
        paymentMethodType: 'Mollie',
        pois: pois.join(',')
      };

      var url = Settings.url('compuzz2', 'paymentMethods.json/generatePaymentLinkTotal', params);

      $.ajax({
        method: 'GET',
        url: url,

        contentType: 'application/json',
        success: _.bind(function (total) {          
          defer.resolve(total);
        }, this),
        error: _.bind(function (error) {
          defer.reject(error);
        }, this)
      });     

      return defer.promise();
    },

    createMolliePaymentLinkMail: function (models, total) {
      var defer = $.Deferred();
      var params = {
        paymentMethodType: 'Mollie'
      };

      var pois = [];
      _.each(models, function (model) { 
        pois.push(model.get('purchaseOrderId'));
      }, this);

      var body = {
        pois: pois,
        total: total
      };

      var url = Settings.url('compuzz2', 'paymentMethods.json/generatePaymentLink', params);

      $.ajax({
        method: 'POST',
        url: url,
        data: JSON.stringify(body),
        contentType: 'application/json',
        success: _.bind(function (link) {
          this.copyToClipboard(link); 
          defer.resolve(link);
        }, this),
        error: _.bind(function (error) {
          defer.reject(error);
        }, this)
      });     

      return defer.promise();
    },

    copyToClipboard: function (value) {
      var $temp = $('<textarea>');
      var brRegex = /<br\s*[\/]?>/gi;
      $('body').append($temp);
      $temp.val(value.replace(brRegex, '\r\n').trim()).select();
      document.execCommand('copy');
      $temp.remove();
    }
  };
});

